import { Component } from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'app-asset-information',
  imports: [
    RouterOutlet
  ],
  templateUrl: './asset-information.component.html',
  styleUrl: './asset-information.component.scss',
})
export class AssetInformationComponent {

}
